import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import "./Layout.css";
import Logo from "./images/logo.png";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/About", label: "About Us" },
    { path: "/Prices", label: "Prices" },
    { path: "/Socials", label: "Socials" },
    { path: "/Contact", label: "Contact Us" },
  ];

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname === path;
  };

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="layout-container">
      <nav className="nav-bar">
        <div className="nav-content">
          <Link to="/" className="nav-logo">
            <img src={Logo} alt="The Party Parlour" className="logo-img" />
            <span className="logo-text">The Party Parlour</span>
          </Link>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={isMobileMenuOpen ? "hamburger open" : "hamburger"}></span>
          </button>

          <div className={`nav-buttons ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </nav>
      <main className="main-content">
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="footer-content">
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} The Party Parlour. All rights reserved.
          </p>
          <div className="footer-links">
            <Link to="/PrivacyPolicy" className="footer-link">
              Privacy Policy
            </Link>
            <span className="footer-divider">|</span>
            <Link to="/TermsOfService" className="footer-link">
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;